import dayjs from "dayjs";
import {
  BULK_FIELDS,
  COMPLETION_DATE_FIELD_MAP,
  getStatusOptions,
} from "./helper";

export const getSelectedBulkFields = (bulkFields) =>
  BULK_FIELDS.filter((item) => bulkFields.includes(item.value));

export const getSelectedBulkType = (selectedBulkFields) => {
  if (!selectedBulkFields.length) return "";
  return selectedBulkFields[0]?.type || "";
};

export const getBulkValueOptions = (
  selectedBulkFields,
  selectedBulkType,
  practiceUsers,
) => {
  if (!selectedBulkFields.length || !selectedBulkType) return [];

  if (selectedBulkType === "status") {
    const uniqueStatuses = [
      ...new Set(
        selectedBulkFields.flatMap((field) => getStatusOptions(field.value)),
      ),
    ];

    return uniqueStatuses.map((status) => ({
      value: status,
      label: status,
    }));
  }

  return practiceUsers.map((user) => ({
    value: user.user_id,
    label: user.user_name || user.email || user.user_id,
  }));
};

export const buildBulkTrackerList = ({
  selectedRows,
  bulkFields,
  bulkValue,
  userData,
}) => {
  return selectedRows.map((row) => {
    const updatedRow = {
      ...row,
      dos: dayjs(row.dos).format("MM/DD/YYYY"),
      last_updated_by: `${userData.first_name} ${userData.last_name}`,
    };

    bulkFields.forEach((field) => {
      updatedRow[field] = bulkValue;

      const completionDateField = COMPLETION_DATE_FIELD_MAP[field];

      if (completionDateField) {
        if (bulkValue === "Completed") {
          updatedRow[completionDateField] =
            row[completionDateField] || dayjs().format("MM/DD/YYYY");
        } else {
          updatedRow[completionDateField] = null;
        }
      }
    });

    return updatedRow;
  });
};
